import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { StorageFile } from "../../../types/StorageFile";
import { array, enumValues, nullable, number, object } from "../../../types/_types";

import artifactContentTypes from "../constants/artifactContentTypes";

export const ArtifactFile = StorageFile.extend({
	contentType: enumValues(artifactContentTypes),
	duration: number().default(0),
	format: nullable(object().passthrough()),
	silences: nullable(
		array(
			object({
				start: number(),
				end: number(),
			}),
		),
	).default(null),
})
	.merge(FirestoreDocument)
	.merge(FirestoreLifecycle);
